import Jsona from "jsona";

const jsonApiFormatter = new Jsona();

const jsonApiDeserialize = (data) => jsonApiFormatter.deserialize(data);

export default jsonApiDeserialize;
